import { useMutation, MutateOptions } from "@tanstack/react-query";

import { CreateUserRequest } from "../../../apiclients/bstinsights";
import useBSTInsightsAPI from "../../../apiclients/api/bstinsightsapi";
import useAcquireToken from "../../AuthToken/Hooks/useAcquireToken";

export type CreateUserResponse = {
  error?: boolean;
  details?: {
    body: string;
    name: string;
  };
};

export type CreateUserOptions = MutateOptions<
  CreateUserResponse,
  Error,
  CreateUserRequest,
  unknown
>;

export const useCreateUser = () => {
  const { getTokenSilently } = useAcquireToken();
  const { saveUser } = useBSTInsightsAPI();

  return useMutation<CreateUserResponse, Error, CreateUserRequest, unknown>({
    mutationFn: async (payload: CreateUserRequest) => {
      const token = await getTokenSilently();
      if (!token) {
        return;
      }
      return await saveUser(token, payload);
    },
  });
};
